import { View } from 'react-native';
import { DropdownItem } from './Item';
import { DropDownItemType } from './types';
import { styles } from './List.styles';

type DropdownListProps = {
  items: DropDownItemType[];
  onItemPress: (title: string) => void;
};

export const DropdownList = ({ onItemPress, items }: DropdownListProps) => {
  return (
    <View style={styles.list}>
      {items.map((item, index) => (
        <DropdownItem key={index} item={item} onItemPress={onItemPress} />
      ))}
    </View>
  );
};
